if (!customElements.get('kr-cookie-preferences')) {
  customElements.define('kr-cookie-preferences', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.controller = new AbortController();
      this.button.addEventListener('click', () => this.openPreferences(), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    async openPreferences() {
      if (this.button.getAttribute('aria-busy') === 'true') return;
      this.button.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      let timeout;
      try {
        for (let attempt = 0; attempt < 40 && !window.privacyBanner?.showPreferences; attempt++) {
          if (!this.isConnected) return;
          await new Promise(resolve => setTimeout(resolve, 150));
        }
        if (!this.isConnected) return;
        if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
        await Promise.race([
          window.privacyBanner.showPreferences(),
          new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Privacy banner timeout')), 8000); })
        ]);
      } catch {
        if (this.isConnected) this.status.textContent = this.status.dataset.error;
      } finally {
        clearTimeout(timeout);
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}
